import RejectTransferForm from './RejectTransferForm';

export default RejectTransferForm;
